import React, { FC } from "react";
import { Outlet } from "react-router-dom";

import Header from "../Header/Header";

/** Shared chrome for the admin area: header only (tables manage their own height). */
const AdminLayout: FC = () => {
  return (
    <div className="flex min-h-screen flex-col">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;
